import { Store } from '@sama/app-state';
import { map, mapValues } from '@sama/micro-dash';
import { logToReduxDevtoolsExtension } from '@sama/rxjs-core';

/**
 * Log state changes to the Redux DevTools extension.
 *
 * Callers must save the returned subscription and call
 * `subscription.unsubscribe()` in `ngOnDestroy`.
 */
export function logStateToDevtools(store: Store<any>, storeName: string) {
  return logToReduxDevtoolsExtension(store.$, {
    name: storeName,
    maxAge: 5,
    autoPause: true,
    stateSanitizer: sanitizeLargeObjects,
  });
}

/**
 * Remove all the giant objects from the state before printing them to the
 * console, because that takes forever.
 */
function sanitizeLargeObjects(obj: any): any {
  if (!(obj instanceof Object)) {
    return obj;
  }

  if (obj.length > 100) {
    return `<${typeof obj} with length ${obj.length}>`;
  }

  if (Array.isArray(obj)) {
    return map(obj, sanitizeLargeObjects);
  }

  return mapValues(obj, sanitizeLargeObjects);
}
